import React from 'react';
import '../styles/Navbar.css';
import { SiDigikeyelectronics } from "react-icons/si";;

export default function Navbar() {
  return (
    <div className='NavbarContainer'>
    <div className='NavbarLeft'>
    <div className='NavbarName'>
        <a href="#home"><SiDigikeyelectronics size ='1.75em' className = "PIcon"/></a>
    </div>
    {/* <div className='NavToggle'>Toggle</div> */}
    </div>
    <div className='NavbarRight'>
        <ul className='NavbarList'>
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#projects">Projects</a></li>
            <li><a href="#contact">Contact</a></li>
        </ul>
    </div>
    </div>
  )
}
